import { TextField as MuiTextField, styled } from '@mui/material';

export const ThinTextField = styled(MuiTextField)`
  width: 275px;
  margin: 0 10px;
  .MuiOutlinedInput-input {
    padding: 12px;
  }
`;
